module.exports = __webpack_public_path__ + "img/calendar.cb2e9cca.svg";